import script from "./left_menu.vue?vue&type=script&setup=true&lang=js"
export * from "./left_menu.vue?vue&type=script&setup=true&lang=js"

import "./left_menu.vue?vue&type=style&index=0&id=d863d4c4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d863d4c4"]])

export default __exports__